
<div class="embed-visual-container"
     [class.embed-visual__no-interaction]="disableInteraction()"
     [class.embed-visual__print]="print()"
     [class.embed-visual__error]="!!errorDetails()"
     [style.height]="pageHeightCss()"
     [class.embed-visual__has-title-and-subtitle]="hasTitle() && hasSubtitle()"
     [class.embed-visual__cross-filter-source]="crossFilterState() == CrossFilterState.Source"
     [class.embed-visual__cross-filter-target]="crossFilterState() == CrossFilterState.Target"
     [class.embed-visual__rendering]="visualRendering()">
  @if (pageHeader()) {
    <ng-container *ngTemplateOutlet="pageHeader(); context: { pageIndex: 0 }"></ng-container>
  }

  <div class="embed-visual__inner">
    <div class="embed-visual__inner-left">
      <div class="embed-visual__top-bottom-wrapper">
        <div class="embed-visual__top" [hidden]="hideTopbar()">
          <div class="embed-visual__top-left text-ellipsis pr-4">
            @if (hasTitle()) {
              <div class="embed-visual__title text-ellipsis" [hidden]="disableTitle()" [title]="title()"
                   [style]="titleStyleCss()">
                <span>{{title()}}</span>
              </div>
            }
            @if (hasSubtitle()) {
              <div class="embed-visual__subtitle text-ellipsis" [hidden]="disableSubtitle()" [title]="subtitle()"
                   [style]="subtitleStyleCss()">
                <span>{{subtitle()}}</span>
              </div>
            }
          </div>
          <div class="embed-visual__top-right">
            <div class="embed-visual__actions">
              <ng-content select="[topbarActionsLeft]"></ng-content>

              @if (showRowCount()) {
                @let rc = rowCount();
                @if (rc) {
                  <div class="embed-visual__row-count">
                    @if (rc.loaded) {
                      <span class="mr-4">Total Rows:</span>
                      <strong>{{rc.rowCount}}</strong>
                    }
                    @else {
                      <loading-rect size="60px 12px"></loading-rect>
                    }
                  </div>
                }
              }

              @if (!disableActions() && !print()) {
                @if (showCrossFilterButton()) {
                  @let noCrossFilters = noCrossFilterApplied();
              
                  <i class="far fa-filter i-13 px-2 mr-4 pointer"
                     [class.cross-filter-button-disabled]="noCrossFilters"
                     ngxTooltip
                     [template]="crossFiltersTooltip"></i>
                  <ng-template #crossFiltersTooltip>
                    <div class="cross-filter-details-popover">
                      @if (noCrossFilters) {
                        <div>
                          <div>
                            <span>No cross filtering applied</span>
                          </div>
                        </div>
                      }
                      @else {
                        @for (g of appliedCrossFilterGroups(); track $index) {
                          <div>
                            @for (f of g.filters; track $index) {
                              <div [innerHTML]="f.description">
                              </div>
                            }

                            @if (!$last) {
                            <div class="cross-filter-details-separator-wrapper">
                              <span>or</span>
                              <div class="cross-filter-details-separator">
                              </div>
                            </div>
                            }
                          </div>
                        }
                      }
                    </div>
                  </ng-template>
                }

                <button trgButton color="white" [matMenuTriggerFor]="actionMenu" class="px-2"
                        (menuOpened)="onActionMenuOpened()"
                        (menuClosed)="onActionMenuClosed()">
                  <i class="far fa-ellipsis-h i-14"></i>
                </button>

                <i [hidden]="!showFocusToggle()" 
                   class="fal {{focused() ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt'}} fs-14 pointer px-2 ml-6"
                   (click)="focusToggleClick()"></i>
              }

              <ng-content select="[topbarActionsRight]"></ng-content>
            </div>
          </div>
        </div>
        <div class="embed-visual__bottom">
          <div class="embed-visual__content" [hidden]="showPlaceholder()">
            @if (canRender()) {
              <pbir-visual-host [busy]="busy()"
                                [visual]="visual()"
                                [dataSource]="visualDataSource"
                                (beforeVisualEvent)="onBeforeVisualEvent($event)"
                                (visualEvent)="onVisualEvent($event)"
                                (rendered)="onVisualRendered($event)"
                                #visualHost>
                <pbir-visual-shell></pbir-visual-shell>
              </pbir-visual-host>
            }
          </div>
        </div>
      </div>
      
      <div class="embed-visual__overlay" [class.visible]="showPlaceholder()">
        <div class="nowrap embed-visual__overlay-inner">
          @if (contentError()) {
            <div class="content-error-wrapper">
              <pbir-visual-content-error-display [error]="contentError()"></pbir-visual-content-error-display>
            </div>
          }
          @else {
            @if (loading() || contentState() == ContentLoadState.Loaded) {
              <div>
                <div class="fs-20">
                  @if (contentState() == ContentLoadState.Refreshing) { <span>Refreshing data...</span> }
                  @else { <span>Loading visual...</span> }
                </div>
                <div class="mt-2 mb-15 fs-12 c-grey-1">
                  <span>Stay tuned to see your data.</span>
                </div>
              </div>
              <app-spinner class="p-relative not-5 ml-10" [diameter]="36" [strokeWidth]="5"></app-spinner>
            }
            @else if (contentState() == ContentLoadState.Unavailable) {
              <span [hidden]="contentState() != ContentLoadState.Unavailable">
                This visual is unavailable.
              </span>
            }
            @else if (contentState() == ContentLoadState.Deleted) {
              <span [hidden]="contentState() != ContentLoadState.Deleted">
                This visual is deleted.
              </span>
            }
            @else if (contentState() == ContentLoadState.Error) {
              <div class="fs-12" [hidden]="contentState() != ContentLoadState.Error">
                <p>
                  <span>An error occurred when loading this visual.</span>
                </p>
              </div>
              <div class="mt-20 d-flex align-items-center" [hidden]="print()">
                <button trgButton color="secondary" class="min-w-100 px-15" center 
                        [hidden]="!errorDetails()"
                        (click)="showErrorDetailsClick(errorDetailsContent)">
                  <span>Details</span>
                </button>
                <button trgButton color="secondary" class="min-w-100 px-15 ml-8" center
                        (click)="reloadClick()">
                  <i class="fas fa-sync i-12 mr-6"></i>
                  <span>Reload</span>
                </button>
              </div>
            }
            @else if (crossFilterState() == CrossFilterState.Target && visualRendering() && firstRenderFinished()) {
              <div>
                <div class="fs-20">
                  <span>Applying filters...</span>
                </div>
                <div class="mt-2 mb-15 fs-12 c-grey-1">
                  <span>Stay tuned to see your data.</span>
                </div>
              </div>
              <app-spinner class="p-relative not-5 ml-10" [diameter]="36" [strokeWidth]="5"></app-spinner>
            }
          }
        </div>
      </div>
    </div>
    <div class="embed-visual__inner-right" [hidden]="!focused()">
      <visual-embed-details [loading]="loadingDetails()" 
                            [visualDto]="visualDto()" 
                            [visual]="visual()"></visual-embed-details>
    </div>
  </div>

  @if (pageFooter()) {
    <ng-container *ngTemplateOutlet="pageFooter(); context: { pageIndex: 0 }"></ng-container>
  }
</div>

<ng-template #diagnosticDetailsContent>
  <div class="embed-visual__diagnostic-details">
    <div class="section">
      <div>
        <label>Visual Id:</label>
        <span>{{visualIdString()}}</span>
      </div>
      <div>
        <label>Created By:</label>
        <span>{{createdByString()}}</span>
      </div>
    </div>
    
    <div class="separator"></div>
    <div class="title">
      <span>Data Load</span>
    </div>
    <div class="section">
      <div>
        <label>Started:</label>
        <span>{{loadStartDate() | date:localizationService.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds}}</span>
      </div>
      <div>
        <label>Finished:</label>
        @if (firstLoadFinished()) {
          <span>{{loadEndDate() | date:localizationService.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds}}</span>
        }
        @else {
          <span>-</span>
        }
      </div>
      <div>
        <label>Duration:</label>
        @if (firstLoadFinished()) {
          <span title="{{loadDurationMsIntString()}}ms">
            {{loadDurationMsIntString()}}ms
          </span>
        }
        @else {
          <span>-</span>
        }
      </div>
      <div>
        <label>Query Plan:</label>
        <span>
          @if (queryId()) {
            @if (queryPlanLoaded()) {
              <a class="underline c-blue pointer" (click)="viewQueryPlanClick()">
                View
              </a>
            }
            @else if (queryPlanLoading()) {
              <span>Loading...</span>
            }
            @else {
              <a class="underline c-blue pointer" (click)="loadQueryPlanClick()">
                Load
              </a>
            }
          }
          @else {
            <span>-</span>
          }
        </span>
      </div>
    </div>

    @if (firstRenderStarted()) {
      <div class="separator"></div>
      <div class="title">
        <span>First Render</span>
      </div>
      <div class="section">
        <div>
          <label>Started:</label>
          <span>{{renderStartDate() | date:localizationService.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds}}</span>
        </div>
        <div>
          <label>Finished:</label>
          @if (firstRenderFinished()) {
            <span>{{renderEndDate() | date:localizationService.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds}}</span>
          }
          @else {
            <span>-</span>
          }
        </div>
        <div>
          <label>Duration:</label>
          @if (firstRenderFinished()) {
            <span title="{{renderDurationMsIntString()}}ms">
              {{renderDurationMsIntString()}}ms
            </span>
          }
          @else {
            <span>-</span>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #errorDetailsContent>
  <code class="embed-visual__error-details">{{errorDetails()}}</code>
</ng-template>

<mat-menu #actionMenu="matMenu" class="ol-10 p-relative mt-4 mr-8 visual-embed-menu" xPosition="before"
          [hasBackdrop]="false">
  @if (!disableActions()) {
    <a *ngIf="allowEdit()" mat-menu-item [disabled]="busy()" [href]="editUrl()" target="_blank">
      <span>Edit</span>
      <i class="fas fa-pencil w-18 text-left d-inline-block"></i>
    </a>

    <button *ngIf="allowApiDownloadLinkDialog()" mat-menu-item (click)="openApiDownloadLinkDialogClick()" [disabled]="busy()">
      <span>API Download Link</span>
      <i class="fas fa-code-branch w-16 mr-2 text-left d-inline-block"></i>
    </button>

    <button *ngIf="allowExport()" mat-menu-item (click)="exportClick()" [disabled]="busy()">
      <span>Export Data</span>
      <i class="fas fa-download w-18 text-left d-inline-block"></i>
    </button>

    <button *ngIf="allowReload()" mat-menu-item (click)="reloadClick()" [disabled]="busy()">
      <span>Reload</span>
      <i class="fas fa-sync w-18 text-left d-inline-block"></i>
    </button>

    <button *ngIf="allowDiagnostics()" mat-menu-item 
            (click)="showDiagnosticDetailsClick(diagnosticDetailsContent)"
            [disabled]="busy()">
      <span>Diagnostics</span>
      <i class="fas fa-wrench w-18 text-left d-inline-block"></i>
    </button>

    @if (hasSelection()) {
      <div class="separator"></div>

      <button mat-menu-item (click)="clearSelectionClick()" [disabled]="busy()">
        <span>Clear Selection</span>
        <i class="far fa-ban w-18 text-left d-inline-block"></i>
      </button>
    }
  }
</mat-menu>

<ng-template #planTemplate>
  @if (queryPlan()) {
    <query-plan-view [plan]="queryPlan()"></query-plan-view>
  }
</ng-template>
